import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { getVimeoOembed } from "utils/vimeo";

import CardHighlightFeatImage from "../../cards/cardHighlightFeatImage";
import CardWithSVGIcon from "../../cards/cardWithSVGIcon";
import GalleryTeaser from "../../galleryTeaser";

const LifeOnBase = ({ lifeonbase, hubdetails }) => {
  const [useFeatVid, setFeatVid] = useState();
  const configDetails = lifeonbase;
  const hubBaseTour = hubdetails?.baseTours?.nodes.slice(-1)[0] ?? {
    acfBaseTour: "",
    content: "",
    taxonomyBaseHighlights: ""
  };

  // const {acfBaseTour : baseTour, content, taxonomyBaseHighlights : highlightIcons } = hubdetails[0]?.baseTours?.nodes[0];
  const baseTour = hubBaseTour?.acfBaseTour;
  const content = hubBaseTour?.content;
  const highlightIcons = hubBaseTour?.taxonomyBaseHighlights;
  const featurevideo =
    baseTour &&
    baseTour.baseVideosGallery &&
    baseTour.baseVideosGallery[0] &&
    baseTour.baseVideosGallery[0].baseVideoTour
      ? baseTour.baseVideosGallery[0].baseVideoTour
      : "";

  useEffect(() => {
    let mounted = true;
    let vimeoId = featurevideo.slice(featurevideo.lastIndexOf("/") + 1);

    if (vimeoId) {
      getVimeoOembed(vimeoId)
        .then((result) => {
          //console.debug("vimeo response", result, mounted);
          if (mounted) setFeatVid(result);
        })
        .catch((err) => console.error("LifeOnBase vimeo error :: ", err));
    }
    return () => (mounted = false);
  }, [featurevideo]);
  return (
    <>
      {configDetails && (
        <div className={"text-generic-text planet:gvi-light-gray-text text-sm"}>
          <h2 className="heading text-left py-5">
            {configDetails.baseTourTitle}
          </h2>
          <div className="divide-y width-divider" />

          {useFeatVid && (
            <div className="py-8">
              <div
                className="w-full"
                dangerouslySetInnerHTML={{ __html: useFeatVid.html }}
              />
            </div>
          )}

          {highlightIcons?.nodes && highlightIcons?.nodes.length > 0 && (
            <div className="higlights-icon-set py-4">
              <h3 className="pb-4">Highlights</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-1">
                {highlightIcons?.nodes?.map((bhicon, idx) => (
                  <CardWithSVGIcon
                    icon={bhicon?.acfBaseHighlight?.bhiIcon}
                    title={bhicon.name}
                    key={idx}
                  />
                ))}
              </div>
            </div>
          )}

          <div className="base-tour-details ">
            {/*
              {baseTour?.baseHighlightsGallery && (
                <div className="base-photo-gallery py-4">
                  <h3 className={"heading"}> Base Highlight Photos</h3>

                  <div className={"relative py-8"}>
                    <GalleryTeaser
                      featVideo={useFeatVid?.html}
                      gallery={baseTour?.baseHighlightsGallery}
                      containerClass={
                        "grid grid-cols-1 grid-rows-1 sm:grid-cols-3 sm:grid-rows-3 gap-3"
                      }
                    />
                  </div>
                </div>
              )}
           */}

            {baseTour?.baseImageGallery && (
              <div className="base-photo-gallery py-4">
                <h3 className={"heading"}> Base Photos</h3>

                <div className={"relative py-8"}>
                  <GalleryTeaser
                    featVideo={useFeatVid?.html}
                    gallery={baseTour?.baseImageGallery}
                    containerClass={
                      "grid grid-cols-1 grid-rows-1 sm:grid-cols-3 sm:grid-rows-3 gap-3"
                    }
                  />
                </div>
              </div>
            )}

            {content && (
              <div
                className="base-tour-description py-4 tab-content_html"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}

            {baseTour?.baseHighlightsBlocks && (
              <div className="base-tour-feature-cards py-4">
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  {baseTour?.baseHighlightsBlocks?.map((bhblock, idx) => {
                    const {
                      baseHighlightsTitle: title,
                      baseHighlightsDesc: desc,
                      baseHighlightGallery: gallery
                    } = bhblock;
                    const bhFeatureImage =
                      gallery && gallery.length > 0 && gallery[0]?.localFile;
                    const bhSourceUrlImage =
                      gallery && gallery.length > 0 && gallery[0]?.sourceUrl;
                    let thekey = `base-highlight-block-${idx}`;

                    return (
                      <CardHighlightFeatImage
                        sourceUrl={bhSourceUrlImage}
                        title={title}
                        desc={desc}
                        featuredImage={bhFeatureImage}
                        key={thekey}
                        readMoreStatus={"hidden"}
                      />
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

LifeOnBase.propTypes = {
  lifeonbase: PropTypes.object,
  hubdetails: PropTypes.object
};

export default LifeOnBase;
